import { T } from '@common/hooks/useTranslation';

/**
 * Generates validation rules for the video questions field.
 * @param t - The translation function.
 * @returns The validation rules object.
 */
export function videoQuestionsRules(t: T) {
  return {
    validate: (value: string) => {
      if (!value) {
        return t('validations.job.videoScreeningQuestions.required');
      }
    }
  };
}
